<template>
  <div class="history">
    <van-nav-bar title="历史浏览" fixed left-arrow @click-left="goBack">
      <van-icon slot="right" @click="emptyGoods()">清空</van-icon>
    </van-nav-bar>
    <div class="van-content">
      <div class="nodata text-cent" v-if="finished && datas == ''">
        <P class="imgbox">
          <img src="/static/images/nodataimg7.png"/>
        </P>
        <p class="text">还没有记录哦~</p>
      </div>
      <van-list v-model="loading" :finished="finished" @load="getDatas" :offset="-1">
        <van-cell-swipe :right-width="50" :left-width="0" v-for="(items,index) in datas" :key="items.id">
          <span slot="left">选择</span>
          <van-cell-group>
            <van-card class="goodsonelist">
              <router-link slot="thumb" class="goodsimgbox"  :to="{path:'/goodslist/goods',query:{id:items.id}}">
                <img onerror="src='/static/errorimg1.png'" :src="items.product_img">
              </router-link>
              <div slot="title" class="ellipseal van-card-title">
                <div class="ellipseal">
                  {{ items.product_name }}
                </div>
                <p style="height: 24px" class="tagbox">
                  <span class="theme-bg radius  " v-if="items.is_new == 1">新品</span>
                  <span class="theme-bg radius  " v-if="items.is_hot == 1">热销</span>
                  <span class="theme-bg radius  " v-if="items.is_rob == 1">限时</span>
                  <span class="theme-col radius rad  jd  theme-bg" v-if="items.dummy == 3">京东</span>
                </p>
              </div>
              <div slot="desc" class="van-card-desc theme-col">{{ items.points_price }} </div>
              <div slot="footer">
                <van-icon class="iconfont icon-gouwuche1 theme-col ft3" @click.stop="addCart(items.id)"></van-icon>
              </div>
            </van-card>
          </van-cell-group>
          <span slot="right"><button class="clearbtn theme-bd theme-bg" @click="removeGoods(items.id,index)">删除</button></span>
        </van-cell-swipe>
        <div v-if="!loading && finished && datas != ''" class="nomore"><span>已经到底了</span></div>
      </van-list>
    </div>
  </div>
</template>

<script>
  export default {
    name: "index",
    data () {
      return {
        datas:[],
        page:0,
        finished:false,
        loading:false,
      }
    },
    methods: {
      goBack: function () {
        history.back(-1);
      },
      onClickRight: function () {
        console.log('按钮');
      },
      getDatas: function () {
        var isUser = localStorage.getItem("BLHuser")
        var _this = this
        setTimeout(() => {
          this.page++
          this.$api.post('WebApi/Member/History/index', {token:isUser,p:this.page}, res => {
            if(res.data.errCode == '0000'){
              if(res.data.data.length==0){
                _this.finished = true;
                _this.loading = false;
              }else{
                for (let i = 0; i < res.data.data.length; i++) {
                  _this.datas.push(res.data.data[i]);
                }
                _this.loading = false;
              }
            }else{
              this.$toast.alert(res.data.desc);
              _this.loading = false;
            }
          })
        },50)
      },
      removeGoods:function (id,index) {
        var _this = this
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Member/History/del', {token:isUser,id:id}, res => {
          if(res.data.errCode == '0000') {
            this.$toast(res.data.desc)
            this.datas.splice(index, 1)
            this.$api.post('WebApi/Member/History/index', {token:isUser,p:this.page}, res => {
              if (res.data.errCode == '0000') {
                if (res.data.data.length != 0) {
                  $.each(res.data.data, function (items, index) {
                    if (!_this.datas[items]) {
                      _this.datas.push(items);
                    }
                  })
                }
              }else if(res.data.errCode == '1002'){
                this.$dialog.confirm({
                  title:'提示',
                  message: '您还未登录是否去登录？'
                }).then(() => {
                  this.$router.push({path:'/login'})
                }).catch(() => {
                  // on cancel
                });
              }else{
                this.$toast(res.data.desc)
              }
            })
          }else{
            this.$dialog.confirm({
              title:'提示',
              message: '您还未登录是否去登录？'
            }).then(() => {
              this.$router.push({path:'/login'})
            }).catch(() => {
              // on cancel
            });
          }
        })
      },
      addCart:function (id) {
        var isUser=localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Member/Cart/addCart', {token:isUser,product_id:id,nums:1,city:this.city,county:this.county,province:this.province,town:this.town}, res => {
          if(res.data.errCode == '0000'){
            this.$toast({
              message:res.data.desc,
              duration:500
            })
          }else if(res.data.errCode == '1002'){
            this.$dialog.confirm({
              title:'提示',
              message: '您还未登录是否去登录？'
            }).then(() => {
              this.$router.push({path:'/login'})
            }).catch(() => {
              // on cancel
            });
          }else{
            this.$toast(res.data.desc)
          }
        })
      },
      emptyGoods:function () {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Member/History/del', {token:isUser}, res => {
          if(res.data.errCode == '0000') {
            this.datas = []
            this.$toast(res.data.desc)
          }else if(res.data.errCode == '1002'){
            this.$dialog.confirm({
              title:'提示',
              message: '您还未登录是否去登录？'
            }).then(() => {
              this.$router.push({path:'/login'})
            }).catch(() => {
              // on cancel
            });
          }else{
            this.$toast(res.data.desc)
          }
        })
      }
    },
    mounted () {
      //this.getDatas()
    },
  }
</script>

<style lang="less" scoped>
  .history{
    .van-nav-bar__right{
      line-height: 50px;
    }
    .goodsonelist.van-card, .goodsonelist{
      margin: 0;
      border: 1px solid #eff3f6;
    }
    .van-cell-group{
      margin-bottom: 0;
    }
    .clearbtn{
      width: 50px;
      height: 100%;
    }
    .radius {
      padding: 0 5px 1px!important;
      -webkit-border-radius:10px 0;
      -moz-border-radius:10px 0;
      border-radius:10px 0 ;

    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/history/index.vue